import { useStore } from "../store/Store";

export default function Footer({ onNav }) {
  const { categories, logoUrl, adminWhatsApp } = useStore();

  return (
    <footer style={{ background:"#1a1a2e", padding:"clamp(40px,5vw,56px) clamp(16px,4vw,40px) clamp(80px,10vw,48px)" }}>
      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(180px,1fr))", gap:32, marginBottom:36 }}>
        <div>
          <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:4 }}>
            <img src={logoUrl} alt="" style={{ height:40, opacity:0.95 }} onError={e=>e.target.style.display="none"}/>
            <div style={{ fontFamily:"'Noto Serif Devanagari',serif", fontSize:22, fontWeight:900, color:"#FF3333" }}>मॅचवेल</div>
          </div>
          <div style={{ fontSize:9, letterSpacing:3, textTransform:"uppercase", color:"#EC4899", marginBottom:14, fontWeight:700 }}>Est. 1979 · Chh. Sambhajinagar</div>
          <p style={{ fontSize:12, lineHeight:1.8, color:"rgba(255,255,255,0.4)", marginBottom:16 }}>Gulmandi Corner, Chhatrapati Sambhajinagar, Maharashtra</p>
          <a href={`https://wa.me/${adminWhatsApp}`} target="_blank" rel="noreferrer"
            style={{ display:"inline-flex", alignItems:"center", gap:8, background:"#25D366", color:"white", padding:"8px 20px", borderRadius:50, fontSize:11, fontWeight:700, textDecoration:"none" }}>
            💬 WhatsApp
          </a>
        </div>
        {[
          { title:"Shop", links: categories.slice(0,5).map(c=>({ l:c, pg:"shop", param:c })) },
          { title:"Account", links:[{ l:"My Account",pg:"account" },{ l:"My Orders",pg:"orders" },{ l:"Wishlist",pg:"wishlist" },{ l:"Track Order",pg:"orders" }] },
          { title:"Help", links:[{ l:"About Us",pg:"about" },{ l:"Contact Us",pg:"contact" },{ l:"FAQ",pg:"faq" },{ l:"Returns & Exchange",pg:"returns" },{ l:"Terms & Conditions",pg:"terms" },{ l:"Privacy Policy",pg:"privacy" }] },
        ].map(col=>(
          <div key={col.title}>
            <h4 style={{ fontSize:9, letterSpacing:3, textTransform:"uppercase", color:"#EC4899", marginBottom:16, fontWeight:700 }}>{col.title}</h4>
            <ul style={{ listStyle:"none", display:"flex", flexDirection:"column", gap:10 }}>
              {col.links.map(({ l, pg, param })=>(
                <li key={l}>
                  <span onClick={()=>onNav(pg, param)} style={{ fontSize:12, color:"rgba(255,255,255,0.4)", cursor:"pointer" }}
                    onMouseEnter={e=>e.target.style.color="#EC4899"}
                    onMouseLeave={e=>e.target.style.color="rgba(255,255,255,0.4)"}>
                    {l}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div style={{ borderTop:"1px solid rgba(255,255,255,0.06)", paddingTop:18, display:"flex", justifyContent:"space-between", flexWrap:"wrap", gap:10 }}>
        <span style={{ fontSize:11, color:"rgba(255,255,255,0.2)" }}>© 2025 Matchwell. Gulmandi Corner, Chhatrapati Sambhajinagar.</span>
        <span style={{ fontFamily:"'Playfair Display',serif", fontStyle:"italic", fontSize:13, color:"rgba(236,72,153,0.4)" }}>Since 1979</span>
      </div>
    </footer>
  );
}
